import { Fragment } from "react";
import { CopyButton } from "./copy-button";

interface CodeBlockProps {
  code: string;
  title?: string;
  /**
   * Wrap each line in place, with a hanging indent so a wrapped line still
   * reads as one, rather than scrolling sideways (task 454). A header block
   * is one long line per header — a CSP runs to 170 characters — and a
   * scrolled block reads as cut off where the overlay scrollbar hides.
   * Copy copies `code` either way.
   */
  wrap?: boolean;
}

export function CodeBlock({ code, title, wrap = false }: CodeBlockProps) {
  return (
    <div className="rounded-lg border bg-muted/50 overflow-hidden">
      {title && (
        <div className="flex items-center justify-between px-4 py-2 border-b bg-muted/80">
          <span className="text-sm font-medium">{title}</span>
          <CopyButton text={code} />
        </div>
      )}
      {wrap ? (
        <pre className="p-4 text-sm">
          {/* The newlines stay in the text, so a selection or textContent
              reads the lines as they are copied; white-space: normal
              collapses them between the lines' own blocks. */}
          <code className="whitespace-normal text-foreground">
            {code.split("\n").map((line, index) => (
              <Fragment key={index}>
                {index > 0 && "\n"}
                <span className="block whitespace-pre-wrap pl-6 -indent-6 wrap-anywhere">
                  {line}
                </span>
              </Fragment>
            ))}
          </code>
        </pre>
      ) : (
        <pre className="p-4 overflow-x-auto text-sm">
          <code className="text-foreground">{code}</code>
        </pre>
      )}
      {!title && (
        <div className="px-4 pb-2">
          <CopyButton text={code} />
        </div>
      )}
    </div>
  );
}
